import { render } from "./ListaVisitantesView.vue?vue&type=template&id=4c13b03f&scoped=true"
import script from "./ListaVisitantesView.vue?vue&type=script&lang=js"
export * from "./ListaVisitantesView.vue?vue&type=script&lang=js"

import "./ListaVisitantesView.vue?vue&type=style&index=0&id=4c13b03f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c13b03f"]])

export default __exports__